'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentDeleteSweep = function ContentDeleteSweep(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z' })
  );
};
ContentDeleteSweep = (0, _pure2.default)(ContentDeleteSweep);
ContentDeleteSweep.displayName = 'ContentDeleteSweep';

exports.default = ContentDeleteSweep;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/content/delete-sweep.js
 ** module id = 1307
 ** module chunks = 0
 **/